<template>
  <!-- 告警球：对应旧 index.html 的 #open_ball + #warningDialogs -->
  <div v-if="appStore.alarmBallVisible" class="alarm-ball" :class="{ 'is-open': open }">
    <div class="alarm-ball__trigger" @click="open = !open">
      <span class="alarm-ball__num">{{ totalCount }}</span>
    </div>

    <div v-show="open" class="alarm-ball__panel">
      <div class="alarm-ball__header">
        <span>实时告警</span>
        <el-icon class="alarm-ball__close" @click="open = false"><Close /></el-icon>
      </div>
      <el-tabs v-model="activeTab" class="alarm-ball__tabs">
        <el-tab-pane :label="`告警列表 (${faults.length})`" name="fault">
          <el-scrollbar height="240px">
            <div v-if="!faults.length" class="alarm-ball__empty">暂无告警</div>
            <div
              v-for="item in faults"
              :key="item.id"
              class="alarm-ball__row"
              @click="goDetail(item)"
            >
              <span class="alarm-ball__row-id">{{ item.gun_id }}</span>
              <span class="alarm-ball__row-name">{{ item.fault_name }}</span>
              <span class="alarm-ball__row-time">{{ item.fault_occur_time }}</span>
            </div>
          </el-scrollbar>
        </el-tab-pane>
        <el-tab-pane :label="`未读消息 (${messages.length})`" name="message">
          <el-scrollbar height="240px">
            <div v-if="!messages.length" class="alarm-ball__empty">暂无消息</div>
            <div v-for="item in messages" :key="item.id" class="alarm-ball__row">
              <span class="alarm-ball__row-id">{{ item.trueName || '匿名' }}</span>
              <span class="alarm-ball__row-name">{{ item.content }}</span>
              <span class="alarm-ball__row-time">{{ timeStamp2String(item.addDateTime) }}</span>
            </div>
          </el-scrollbar>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import { useAppStore } from '@/store/app'
import { getNewFaultApi, getUnReadMessageApi, getFaultAllCountApi } from '@/api/common'
import { timeStamp2String } from '@/utils/date'

/**
 * 告警球 —— 对应旧 index.html 的告警弹框 + 告警球。
 * 旧实现把告警列表用字符串拼接塞进 DOM（index.js getFaultFun，约 50 行字符串拼接），
 * 这里改为数据驱动渲染。
 */

const router = useRouter()
const appStore = useAppStore()

const open = ref(false)
const activeTab = ref('fault')
const faults = ref<any[]>([])
const messages = ref<any[]>([])
const totalCount = ref(0)
let timer: ReturnType<typeof setInterval> | null = null

async function load() {
  try {
    faults.value = (await getNewFaultApi()) || []
  } catch {
    faults.value = []
  }
  try {
    messages.value = (await getUnReadMessageApi()) || []
  } catch {
    messages.value = []
  }
  try {
    totalCount.value = (await getFaultAllCountApi()) as any as number
  } catch {
    totalCount.value = faults.value.length
  }
}

function goDetail(row: any) {
  router.push(`/faultmanage/faultDetail?id=${row.id}`)
}

onMounted(() => {
  load()
  timer = setInterval(load, 100000)
})

onBeforeUnmount(() => {
  if (timer) clearInterval(timer)
})
</script>

<style scoped lang="scss">
.alarm-ball {
  position: fixed;
  right: 18px;
  bottom: 90px;
  z-index: 2000;

  &__trigger {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: $c-danger;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 3px 12px rgba(240, 55, 50, 0.45);
    transition: transform 0.15s;

    &:hover {
      transform: scale(1.06);
    }
  }

  &__num {
    font-size: 16px;
    font-weight: 700;
  }

  &__panel {
    position: absolute;
    right: 0;
    bottom: 58px;
    width: 380px;
    background: #fff;
    border-radius: $radius;
    box-shadow: $shadow-md;
    padding: 10px 12px 4px;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    font-weight: 600;
    color: $c-text;
    margin-bottom: 4px;
  }

  &__close {
    cursor: pointer;
    color: $c-text-secondary;
  }

  &__empty {
    text-align: center;
    color: $c-text-secondary;
    font-size: 13px;
    padding: 40px 0;
  }

  &__row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 7px 4px;
    font-size: 12px;
    border-bottom: 1px dashed $c-border-light;
    cursor: pointer;

    &:hover {
      background: #f5f9ff;
    }
  }

  &__row-id {
    color: $c-primary;
    flex-shrink: 0;
  }

  &__row-name {
    flex: 1;
    color: $c-danger;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__row-time {
    color: $c-text-secondary;
    flex-shrink: 0;
  }
}
</style>
